import * as l from './BodyHeight.loc.js';
import { defineMeasurement } from './ScalarMeasurement.js';
/**
 * Patient-reported body height. Stored canonically in centimeters (LOINC 8302-2); offered in cm and in.
 * Factors are relative to a millimeters base, so in → cm normalizes as `value * 25.4 / 10`.
 */
export const BodyHeight = defineMeasurement({
    units: {
        /** Centimeters (canonical). */
        cm: 10,
        /** Inches. */
        in: 25.4,
    },
    canonical: 'cm',
    label: l.label,
    unitLabel: l.unitLabel,
    loinc: '8302-2',
    step: 1,
    min: 10,
});
//# sourceMappingURL=BodyHeight.js.map